import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { SelectedTeamService, TeamsCrudService } from '@tokenbox/services';
import { ButtonDirective, ButtonIcon, ButtonLabel } from 'primeng/button';
import { PrimeIcons } from 'primeng/api';
import { SidebarMenuComponent } from '../sidebar-menu/sidebar-menu.component';
import { PaymentService } from '../../../../shared/payment/services/payment.service';

@Component({
  selector: 'dt-sidebar-footer',
  imports: [ButtonDirective, ButtonIcon, ButtonLabel, SidebarMenuComponent],
  templateUrl: './sidebar-footer.component.html',
  styleUrl: './sidebar-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarFooterComponent {
  public readonly hideUpgradeButton = input<boolean>(false);

  protected readonly PrimeIcons = PrimeIcons;
  private teamsCrudService = inject(TeamsCrudService);
  public readonly paymentService = inject(PaymentService);
  private selectedTeamService = inject(SelectedTeamService);

  private selectedTeam = this.selectedTeamService.selectedTeam;

  showUpgradeButton = computed(() => {
    const plan = this.selectedTeam()?.plan;
    const canManageTeam = this.selectedTeam()?.ownPermissions?.MANAGE_TEAM;
    return plan && !plan.paidPlan && canManageTeam;
  });

  upgradeUrl = computed(() => {
    const teams = this.teamsCrudService.allTeams();
    if (teams[0]?.id) {
      return this.paymentService.buildCheckoutUrlForCurrentUser(teams[0].id);
    }
    return `/admin/teams`;
  });
}
